import React, { useState } from 'react'
import PageLayout from '../../../layoutcontainers/PageLayout'
import { Alert, Button, Container, Snackbar, TextField, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { BASE_URL } from '../../Utils/Baseurl'
import { useNavigate, useParams } from "react-router-dom";

const ResetPassword = () => {
    const navigate = useNavigate();
    const [data, setData] = useState({
        password: '',
        confirmPassword: '',
        passwordStatus: 'unchecked',
        confirmPasswordStatus: 'unchecked',
        passwordError: '',
        confirmPasswordError: ''
    })
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'info',
    });
    const { uidb64, token } = useParams();

    // Password validation: at least 8 characters, 1 uppercase, 1 lowercase, 1 number
    const validatePassword = (password) => {
        const regex =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()[\]{}<>.,+=_-]).{8,}$/;

        return regex.test(password);
    };


    // Handle input changes for both fields
    const handleChange = (e) => {
        const { name, value } = e.target;

        setData((prev) => {
            const newData = { ...prev, [name]: value };

            // Validate password
            if (name === 'password') {
                const isValid = validatePassword(value);

                newData.passwordStatus = value
                    ? isValid
                        ? 'valid'
                        : 'invalid'
                    : 'unchecked';

                newData.passwordError = value
                    ? isValid
                        ? ''
                        : 'Password must be at least 8 characters and include uppercase, lowercase, number, and special character'
                    : '';
            }

            // Validate confirm password
            if (name === 'confirmPassword') {
                newData.confirmPasswordStatus = value
                    ? value === newData.password
                        ? 'valid'
                        : 'invalid'
                    : 'unchecked';

                newData.confirmPasswordError = value
                    ? value === newData.password
                        ? ''
                        : 'Passwords do not match'
                    : '';
            }

            // Revalidate confirm password if password changes
            if (name === 'password' && newData.confirmPassword) {
                newData.confirmPasswordStatus =
                    newData.confirmPassword === value ? 'valid' : 'invalid';

                newData.confirmPasswordError =
                    newData.confirmPassword === value ? '' : 'Passwords do not match';
            }

            return newData;
        });
    };


    // Handle form submission

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar({ ...snackbar, open: false });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (
            data.passwordStatus === 'valid' &&
            data.confirmPasswordStatus === 'valid'
        ) {
            try {
                const response = await axios.post(`${BASE_URL}api/password-reset-confirm/`, {
                    password: data.confirmPassword,
                    uidb64: uidb64,
                    token: token
                });

                console.log('Password reset successful:', response.data);
                setSnackbar({
                    open: true,
                    message: `Password reset successful`,
                    severity: 'success',
                });
                navigate('/sign-in');
            } catch (error) {
                if (error.response) {
                    console.error('Reset failed:', error.response.data);
                } else {
                    console.error('Error:', error.message);
                }
                setSnackbar({
                    open: true,
                    message: `Failed to reset password`,
                    severity: 'error',
                });
            }
        } else {
            setData((prev) => ({
                ...prev,
                passwordError:
                    prev.passwordStatus !== 'valid'
                        ? 'Password must be at least 8 characters with 1 uppercase, 1 lowercase, and 1 number'
                        : prev.passwordError,
                confirmPasswordError:
                    prev.confirmPasswordStatus !== 'valid'
                        ? 'Passwords do not match'
                        : prev.confirmPasswordError
            }));
        }
    };


    return (
        <PageLayout background="white" height="100%" showNavbar disableFooter>
            <Container
                maxWidth="sm"
                sx={{
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center'
                }}
            >
                <Typography
                    variant="h4"
                    component="h1"
                    gutterBottom
                    sx={{ fontWeight: 'bold' }}
                >
                    Project Management
                </Typography>

                <Typography
                    variant="h6"
                    component="h2"
                    gutterBottom
                    sx={{ mt: 2 }}
                >
                    Set New Password
                </Typography>

                <TextField
                    placeholder="Enter new password"
                    variant="outlined"
                    type="password"
                    name="password"
                    value={data.password}
                    onChange={handleChange}
                    fullWidth
                    sx={{ mt: 2, maxWidth: '300px' }}
                    error={data.passwordStatus === 'invalid'}
                    helperText={data.passwordError}
                />

                <TextField
                    placeholder="Confirm new password"
                    variant="outlined"
                    type="password"
                    name="confirmPassword"
                    value={data.confirmPassword}
                    onChange={handleChange}
                    fullWidth
                    sx={{ mt: 2, maxWidth: '300px' }}
                    error={data.confirmPasswordStatus === 'invalid'}
                    helperText={data.confirmPasswordError}
                />

                <Button
                    variant="contained"
                    fullWidth
                    onClick={handleSubmit}
                    disabled={
                        data.passwordStatus !== 'valid' ||
                        data.confirmPasswordStatus !== 'valid'
                    }
                    sx={{
                        mt: 2,
                        maxWidth: '300px',
                        backgroundColor: '#5f6ec2',
                        color: '#fff',
                        textTransform: 'none',
                        padding: '10px 0',
                        '&:hover': {
                            backgroundColor: '#5f6ec2'
                        }
                    }}
                >
                    Reset Password
                </Button>

                <Link
                    to="/login"
                    style={{
                        mt: 3,
                        color: '#666',
                        fontSize: '10px',
                        textDecoration: 'none'
                    }}
                >
                    Return to login
                </Link>
            </Container>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </PageLayout>
    )
}

export default ResetPassword